import React from 'react'

import classNames from 'classnames'

import { getFieldPlaceholder } from 'features/views/ListView/Actions/utils'

import { Body } from 'ui/components/Text'

import { EditableAttribute } from './types'

import { EditableAttributeValuePlaceholderStyle } from './EditableAttribute.css'

type ValuePlaceholderProps = React.ComponentPropsWithoutRef<typeof Body> & {
    field: EditableAttribute
    isEditable?: boolean
}

export const ValuePlaceholder = React.forwardRef<HTMLSpanElement, ValuePlaceholderProps>(
    ({ field, isEditable = false, className, ...props }, ref) => {
        const placeholder = getFieldPlaceholder(field.field, isEditable)

        return (
            <Body
                ref={ref}
                size="m"
                color="textWeakest"
                className={classNames(EditableAttributeValuePlaceholderStyle, className)}
                {...props}
            >
                {placeholder}
            </Body>
        )
    }
)
